/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export class MemoryStorage {
	private storage: Map<symbol, unknown> = new Map();

	public has(key: symbol): boolean {
		return this.storage.has(key);
	}

	public get(key: symbol): unknown {
		return this.storage.get(key);
	}

	public set<T extends unknown>(key: symbol, value: T): void {
		this.storage.set(key, value);
	}

	public getOrSet<T extends unknown>(key: symbol, defaultValue: T): T | unknown {
		if (!this.has(key)) {
			this.set(key, defaultValue);
		}

		return this.get(key);
	}
}
